import { ONBOARDINGS } from '../constants';
import type {
  OnboardingKeys,
  OnboardingStepConfig,
  DisplayStepConfig,
} from '../types';

export const getDisplayStep = (
  onboardingKey: OnboardingKeys,
  step: OnboardingStepConfig,
  subStep = 0
): DisplayStepConfig | null => {
  if (!step || !onboardingKey) {
    return null;
  }

  const isLastSubStep = subStep === step.steps.length - 1 || !step.steps.length;
  const onboardingData = ONBOARDINGS[onboardingKey].data;
  const onboardingStep = isLastSubStep
    ? Object.values(onboardingData).find(
        ({ index }) => index === step.index + 1
      )
    : step;

  if (!onboardingStep?.steps.length) {
    return null;
  }

  return { ...onboardingStep, currentSubStep: isLastSubStep ? 0 : subStep + 1 };
};
